import { BlockBlobClient } from '@azure/storage-blob';
import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import {
  STORAGE_SERVICE,
  type IStorageService,
} from '@common/services/storage/storage.service.interface';
import { convertFileToArrayBuffer } from '@common/utils/file.util';
import { container } from 'tsyringe';
import { join } from 'urlcat';

export default class StorageService implements IStorageService {
  constructor() {
    this.uploadFileToUrl = this.uploadFileToUrl.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  private handleError(error: unknown): Promise<never> {
    if (error instanceof Error) {
      container
        .resolve(LOG_SERVICE)
        .captureError(error, undefined, { source: STORAGE_SERVICE.toString() });
    } else {
      container
        .resolve(LOG_SERVICE)
        .captureError(
          new Error(STORAGE_SERVICE.toString()),
          { error },
          { source: STORAGE_SERVICE.toString() },
        );
    }

    throw error;
  }

  // eslint-disable-next-line class-methods-use-this
  async uploadFileToUrl(url: string, file: File): Promise<string | null> {
    try {
      const arrayBuffer = await convertFileToArrayBuffer(file);
      if (!arrayBuffer) return null;

      const blockBlobClient = new BlockBlobClient(url);
      await blockBlobClient.uploadData(arrayBuffer, {
        blobHTTPHeaders: { blobContentDisposition: 'inline', blobContentType: file.type },
      });

      const blobUrl = new URL(blockBlobClient.url);

      return join(blobUrl.origin, '/', blobUrl.pathname);
    } catch (error) {
      return this.handleError(error);
    }
  }
}
